import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { PROPOSAL_KEYS } from "~/api/cache"

import type { PowurOsPricingDto } from "../dto/proposal.dto"
import { ProposalService } from "../services/proposal.service"

const proposalService = new ProposalService()

export default function useFetchProposalPricing(
  id: string,
): UseQueryResult<PowurOsPricingDto, unknown> {
  return useQuery({
    queryKey: PROPOSAL_KEYS.pricing(id),
    queryFn: () => {
      return proposalService.fetchProposalPricing(id)
    },
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
